











































































































import { User } from '@/types/GlobalTypes';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import { get, isEmpty } from 'lodash';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoDate from '../co-date/CoDate.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';

export default {
    name: 'CoUser',
    components: {
        CoThumbnail,
        CoLink,
        CoText,
        CoDate,
        CoSkeleton,
    },
    props: {
        User: {
            type: Object as () => User,
            default: () => ({}), // Default to an empty object to avoid undefined errors
        },
        Loading: {
            type: Boolean,
            default: false,
        },
        showLink: {
            type: Boolean,
            default: true,
        },
        linkType: {
            type: String,
            default: 'auto',
            validator: (value) => {
                return ['auto', 'admin', 'user'].includes(value);
            },
        },
        showHeadline: {
            type: Boolean,
            default: false,
        },
        showThumbnail: {
            type: Boolean,
            default: true,
        },
        showName: {
            type: Boolean,
            default: true,
        },
        Timestamp: {
            type: [Number, String, Date],
            default: null,
        },
        Size: {
            type: String,
            default: 'md', // Default size can be 'sm', 'ms', 'md'
            validator: (value) => {
                return ['sm', 'ms', 'md'].includes(value);
            },
        },
    },
    data() {
        return {
            // Define any local state here if needed
        };
    },
    computed: {
        Name() {
            return this.User?.Name || (this.User?.FirstName || '') + ' ' + (this.User?.LastName || '') || null;
        },
        Slug() {
            return this.User?.Slug || '';
        },
        ImageURL() {
            return this.User?.ImageURL || null;
        },
        Headline() {
            return this.User?.Bio || null;
        },
        userStatus() {
            return this.User?.Status === 7 ? 'guest' : null; // Assuming 7 is the status for guest users
        },
        asAdmin() {
            return this.$store?.state?.me?.Permissions?.includes('space_admin'); // viewing user is an admin
        },
        isDeleted() {
            // Check if the user is deleted
            return !this.User || isEmpty(this.User) || !this.Name;
        },
        viewingUserSpaceID() {
            // Get the space ID of the viewing user
            return this.$store?.state?.space?.ID || null;
        },
        Icon() {
            if (this.isDeleted) return { icon: 'eye-slash' }; // Icon-label for deleted users
            if (this.userStatus === 'guest') return { icon: 'lock', color: 'var(--c-lemon)' }; // Icon-label for guest users
            if (
                (this.User?.Space?.FaviconURL || this.User?.Space?.PrimaryColor) &&
                this.viewingUserSpaceID !== this.User?.Space?.ID
            ) {
                // If the user has a space, use its favicon or primary color
                return {
                    color: this.User?.Space?.PrimaryColor || null,
                    imageURL: this.User?.Space?.FaviconURL || null,
                };
            }
            return null;
        },
    },
    methods: {
        // Define methods to handle user interactions
        get,
        clickHandler() {
            if (!get(this.User, 'ID', null)) return; // Ensure User ID exists before proceeding
            // Handle click events based on the Link prop and the status of the viewing user
            if (!this.showLink || this.isDeleted || this.Loading) return; // Prevent interaction if user is deleted or loading
            // navigate to internal links
            if (this.linkType !== 'admin' || this.$store?.state?.isInMobile || !this.asAdmin) {
                // as a user or in mobile app
                this.$router.push({ path: `/profile/${get(this.User, 'Slug')}` });
            } else {
                // as an admin
                this.$router.push({ path: `/admin/community/member/view/${get(this.User, 'ID')}` });
            }
        },
    },
};
